var _path, _g, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIncludedDrinks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons_Glass_Line",
    "data-name": "icons/Glass/Line",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.64,
    height: 32,
    viewBox: "0 0 20.64 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M16.639,2.667H4A1.333,1.333,0,0,0,2.672,4.111l2,24A1.333,1.333,0,0,0,6,29.333h8.639a1.333,1.333,0,0,0,1.329-1.223l2-24A1.333,1.333,0,0,0,16.639,2.667ZM4,0A4,4,0,0,0,.014,4.332l2,24A4,4,0,0,0,6,32h8.639a4,4,0,0,0,3.986-3.668l2-24A4,4,0,0,0,16.639,0Z",
    transform: "translate(0)",
    fill: "#141416",
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shape-2",
    "data-name": "Shape",
    transform: "translate(6.32 16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_4A0DABBC-F54D-4E8A-A4C3-A4551DB6983B",
    "data-name": "4A0DABBC-F54D-4E8A-A4C3-A4551DB6983B",
    d: "M1.333,2.667A1.333,1.333,0,1,0,0,1.333,1.333,1.333,0,0,0,1.333,2.667Z",
    fill: "#141416"
  }), /*#__PURE__*/React.createElement("path", {
    id: "FDB0BCCC-A191-436F-899C-3F3F7C428FF6",
    d: "M1.333,2.667A1.333,1.333,0,1,0,0,1.333,1.333,1.333,0,0,0,1.333,2.667Z",
    transform: "translate(5.333 6.667)",
    fill: "#141416"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M14.426,2.648A20.039,20.039,0,0,1,7.768,1.4L7.745,1.4A22.768,22.768,0,0,0,0,0L.223,2.673A20.039,20.039,0,0,1,6.88,3.918l.022.007a22.634,22.634,0,0,0,7.3,1.384Z",
    transform: "translate(2.996 8.006)",
    fill: "#141416"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncludedDrinks);
export default __webpack_public_path__ + "static/media/includedDrinks.58b3abf79245082eb0e7a82064af8e8c.svg";
export { ForwardRef as ReactComponent };